import PropTypes from "prop-types";
import appUserRoutes from "../../appUserRoutes";
import React from "react";
import apiUser from "../../apiUser";
import {Col, Row} from "reactstrap";
import {showModal} from "../SmsModalContainer/reducer/ModalActions";
import {useDispatch} from "react-redux";
import Tooltip from "../../componentsReusable/Tooltip";
import ClientDescription from "./ClientDescription";
import {toast} from "react-toastify";
import phoneNumberLabel from "../../utils/phoneNumberLabel";
import {useTranslation} from "react-i18next";
import ObjectLinkWithDetails from "../../componentsReusable/ObjectLinkWithDetails";
import workerHasPrivilege from "../../utils/workerHasPrivilege";

function ClientLabel(props) {
  const { t } = useTranslation('client_label')
  const dispatch = useDispatch();
  const [clientData, setClientData] = React.useState();

  if(!props.client){
    return <i>{t('empty')}</i>
  }

  let name = [];

  switch (props.client.type) {
    case 'person': {
      props.client.firstname && name.push(props.client.firstname);
      props.client.lastname && name.push(props.client.lastname);
      break;
    }
    case 'company': {
      name.push(props.client.name);
      break;
    }
    default: {
      if(props.client.name){
        name.push(props.client.name);
      }
      break;
    }
  }

  const getDetailsBody = () => {
    return <>
      <Row className="text-nowrap">
        <Col xs={12} md={6}>
          <span className="text-secondary">{t('common:email')}</span>
          <span className="ml-2">{clientData.email && <a href={`mailto:${clientData.email}`}>{clientData.email}</a>}</span>
        </Col>
        <Col xs={12} md={6}>
          <span className="text-secondary">{t('common:phone')}</span>
          <span className="ml-2">
            {(workerHasPrivilege('smsManage.create') && clientData.phoneNumber?.number) && <Tooltip msg={t('send_sms_tooltip')}>
              <span className="cursor-pointer" onClick={() => dispatch(showModal({
                modalProps: {
                  isOpen: true,
                  clientSelectDisabled: true,
                  data: {
                    repairOrder: null,
                    client: clientData.id,
                    clients: [],
                    phoneNumber: clientData.phoneNumber,
                    content: '',
                    sendAt: null,
                  }
                }
              }))}>
                <i className="fas fa-sms mr-1"/>
                <span>{phoneNumberLabel(clientData.phoneNumber)}</span>
              </span>
            </Tooltip>}
          </span>
        </Col>
        <Col xs={12} className="mt-2">
          <ClientDescription
            value={clientData.description}
            onChange={description => {
              setClientData({
                ...clientData,
                description,
              })
              apiUser.clients.patch(props.client.id, { description })
                .then(() => toast.success(t('description_saved')))
            }}
          />
        </Col>
      </Row>
    </>
  }

  return <ObjectLinkWithDetails
    icon="fas fa-address-book"
    link={appUserRoutes.client(props.client.id)}
    disableRedirect={!props.linked}
    linkText={name.join(' ')}
    objectData={clientData ? {
      title: name.join(' '),
      body: () => getDetailsBody(),
    } : null}
    getObjectData={() => apiUser.clients.get(props.client.id).then(res => setClientData(res.data))}
  />
}

ClientLabel.defaultProps = {
  linked: true,
  className: '',
};

ClientLabel.propTypes = {
  target: PropTypes.string,
  className: PropTypes.string,
  linked: PropTypes.bool,
  client: PropTypes.shape({
    id: PropTypes.number.isRequired,
  }),
};

export default ClientLabel;
